module.exports = __webpack_public_path__ + "media/images/lavo-7aaacd505694cadf09967b23702328b5.jpg";